export default "__VITE_ASSET__b8540854__"